// ISO 8601 hafta hesaplama yardımcıları.
//
// Backend (utils.ISOWeek) ile tutarlı olmak için:
// - Haftalar Pazartesi başlar, Pazar biter.
// - 4 Ocak'ı içeren hafta = yılın 1. haftası.
// - Yıl geçişinde takvim yılı ile ISO yılı farklı olabilir (30 Aralık 2024 → 2025 W1).
//
// Not: `date-fns/getISOWeek` veya `dayjs/plugin/isoWeek` de aynı sonucu üretir.
// Ekstra dependency almak istemedik, standart implementasyon burada.

// Turkey timezone offset (UTC+3). Hafta hesaplamasında day-level çalıştığı için
// tam olarak +3 uygulamak yeterli — DST yok Türkiye'de.
function toTurkeyDate (date) {
  const d = date instanceof Date ? new Date(date.getTime()) : new Date(date)
  // Sadece display için değil hesaplama için Turkey saati istiyoruz.
  const utcMs = d.getTime() + d.getTimezoneOffset() * 60000
  return new Date(utcMs + 3 * 3600000)
}

/**
 * Verilen tarihin ait olduğu haftanın Pazartesi'sini döner.
 * Türkiye timezone'da hesaplanır.
 */
export function weekStartDate (date) {
  const d = toTurkeyDate(date)
  const day = d.getDay() // 0 = Pazar, 1 = Pazartesi, ...
  const diff = day === 0 ? 6 : day - 1
  const monday = new Date(d)
  monday.setDate(d.getDate() - diff)
  monday.setHours(0, 0, 0, 0)
  return monday
}

/**
 * ISO 8601 (year, week) tuple'ı döner.
 * Backend'in `utils.ISOWeek(t)` fonksiyonu ile bit-bit uyumlu olmalı.
 * Örn: 30 Aralık 2024 Pazartesi → { year: 2025, week: 1 }
 */
export function isoWeek (date) {
  const d = toTurkeyDate(date)
  // ISO 8601: hafta Perşembe'ye kilitlenir; o günün yılı = ISO yıl.
  const target = new Date(d)
  target.setHours(0, 0, 0, 0)
  const dayNr = (target.getDay() + 6) % 7 // Pazartesi=0
  target.setDate(target.getDate() - dayNr + 3) // Perşembe'ye git
  const firstThursday = new Date(target.getFullYear(), 0, 4)
  const firstThursdayDayNr = (firstThursday.getDay() + 6) % 7
  firstThursday.setDate(firstThursday.getDate() - firstThursdayDayNr + 3)
  const week = 1 + Math.round((target - firstThursday) / (7 * 24 * 3600 * 1000))
  return { year: target.getFullYear(), week }
}

/**
 * Bir gruplama anahtarı — display için kullanılır.
 * "2025-01" gibi bir string döner (padded).
 */
export function weekKey (date) {
  const { year, week } = isoWeek(date)
  return `${year}-${String(week).padStart(2, '0')}`
}
